<div class="modal-header">
    <h5 class="pt-4 ps-4">Editar campaña</h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-dialog-content class="mat-typography">
    <span>Edita la información de la campaña:</span>
    <form autocomplete="off" [formGroup]="formCampaign" (ngSubmit)="ruSure()" class="mt-3" id="campaignForm">
        <small>Campo obligatorio *</small>
        <div class="row mt-2">
            <div class="col-sm-12">
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name">
                    <mat-icon matSuffix>account_circle</mat-icon>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" class="text-white" form="campaignForm" type="submit">Guardar <mat-icon>save</mat-icon></button>
</mat-dialog-actions>
